enum UserRoles {
  MANAGER = 'MANAGER',
  OWNER = 'OWNER',
  PLANNER_RESERVE_CAMPAIGN_ID = 'PLANNER_RESERVE_CAMPAIGN_ID',
  READ_ONLY = 'READ_ONLY',
  REPORTING_ONLY = 'REPORTING_ONLY',
  SALES_MANAGER = 'SALES_MANAGER',
  SALES_PLANNER = 'SALES_PLANNER',
  SCHEDULER = 'SCHEDULER',
  CURATOR = 'CURATOR',
}

export default UserRoles;
